import { QueryClient } from "@tanstack/react-query";
import { isAxiosError, isCancel } from "axios";

const retryCount = 3; // The current default for react-query as of v4.33.0

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      onError(error) {
        if (isCancel(error) && error.message?.startsWith("401 (Unauthorized)")) {
          queryClient.cancelQueries();
        }
      },
      refetchOnWindowFocus: false,
      retry(failureCount, error) {
        // Never retry cancelled requests
        if (isCancel(error)) return false;

        // Don't retry server errors (5xx) - these are unlikely to resolve with retries
        if (isAxiosError(error) && error.response?.status) {
          const { status } = error.response;
          if (status >= 500) return false;
          // Also don't retry auth errors
          if (status === 401 || status === 403) return false;
        }

        return failureCount < retryCount;
      },
    },
  },
});

export default queryClient;
